"use client";

import { forwardRef, useState } from "react";
import { cn } from "./lib/utils";

export const Tag = forwardRef<
	HTMLInputElement,
	{
		name: string;
		prefix?: string;
		className?: string;
		disabled?: boolean;
		onSelect?: (value: string) => void;
	}
>(({ name, className, prefix, onSelect, ...props }, ref) => {
	const [selected, setSelected] = useState(false);

	const hash = prefix ? `${prefix}.${name}` : name.toLowerCase();

	return (
		<label
			className={cn(
				"bg-surface",
				"rounded-input",
				"cursor-pointer",
				"border px-md py-sm text-sm",
				"active:scale-[.97]",
				selected ? "border-surface-brand" : "border-border-primary",
				className,
			)}
		>
			<input
				className="hidden h-0 w-0"
				name={hash}
				onClick={() => {
					onSelect && onSelect(name);
					setSelected((state) => {
						return !state;
					});
				}}
				ref={ref}
				type="checkbox"
				{...props}
			/>
			{name}
		</label>
	);
});

Tag.displayName = "Tag";
